<template>
  <div class="top-content" :style="`background:${bgcolor}`">
    <div class="head" @click="jumpHome()">
      <div class="head-left"><img src="../../assets/img/LOGO.png" @click="jumpHome()"> <span>{{title}}</span></div>
      <router-link to="./" class="head-right">返回首页</router-link>
    </div> 
  </div>

</template>

<script>
export default {
  props: {
    title: {
      required: true
    },
    bgcolor: {
      default: "#fff"
    }
  },
  methods: {
    jumpHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/custom.scss";

.top-content {
  min-width: $width;

  .head {
    width: $width;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .head-left {
      display: flex;
      align-items: center;

      img {
        margin: 5px 0 0 0;
        &:hover {
          cursor: pointer;
        }
      }

      span {
        color: #818181;
        padding-left: 8px;
        font-size: 16px;
        border-left: 2px solid #cecece;
      }
    }

    .head-right {
      text-decoration: none;
      font-size: 13px;
      color: #929292;
    }
  }
}
</style>
